webpackJsonp([7],{

/***/ 829:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

__webpack_require__(842);

var _vuex = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    model: {
        prop: ['currentSong']
    },
    props: {
        newsdata: Array,
        labelname: String,
        tipshow: Boolean,
        goUrl: Function,
        limit: Number,
        total: Number,
        handlePageChange: Function,
        urladdr: String
    },
    data: function data() {
        return {
            fullScreen: false

        };
    },
    created: function created() {
        console.debug("created> currentSong:%o", this.currentSong);
    },
    mounted: function mounted() {},

    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({})),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({}), {
        open: function open() {},
        cdCls: function cdCls() {},
        showPlayList: function showPlayList() {},
        ready: function ready() {},
        error: function error() {},
        updateTime: function updateTime() {},
        ended: function ended() {}
    })
};

/***/ }),

/***/ 835:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(821)();
// imports


// module
exports.push([module.i, "#playerbar .mini-player{display:flex;align-items:center;position:fixed;left:0;bottom:0;z-index:180;width:100%;height:3rem;background:#333}#playerbar .mini-player .icon{flex:0 0 40px;width:40px;padding:0 10px 0 20px}#playerbar .mini-player .icon img{border-radius:50%}#playerbar .mini-player .icon img.play{animation:rotate 10s linear infinite}#playerbar .mini-player .icon img.pause{animation-play-state:paused}#playerbar .mini-player .text{display:flex;flex-direction:column;justify-content:center;flex:1;line-height:20px;overflow:hidden}#playerbar .mini-player .text .name{margin-bottom:2px;font-size:16px;color:red}#playerbar .mini-player .text .desc{font-size:16px;color:blue}#playerbar .mini-player .control{flex:0 0 30px;width:30px;padding:0 10px}#playerbar .mini-player .control .icon-pause-mini,#playerbar .mini-player .control .icon-play-mini,#playerbar .mini-player .control .icon-playlist{font-size:30px}#playerbar .mini-player .control .icon-mini{font-size:32px;position:absolute;left:0;top:0}", "", {"version":3,"sources":["D:/project/beltline-git-clone/src/static/style/common/D:\\project\\beltline-git-clone/src\\static\\style\\common\\playerbar.scss"],"names":[],"mappings":"AAAA,wBAEI,aAAa,AACb,mBAAmB,AACnB,eAAe,AACf,OAAO,AACP,SAAS,AACT,YAAY,AACZ,WAAW,AACX,YAAY,AACZ,eAAgB,CA8CjB,AAxDH,8BAYM,cAAc,AACd,WAAW,AACX,qBAAsB,CAUrB,AAxBP,kCAgBQ,iBAAkB,CAOjB,AAvBT,uCAkBY,oCACF,CAAE,AAnBZ,wCAqBY,2BACF,CAAE,AAtBZ,8BA0BM,aAAa,AACb,sBAAsB,AACtB,uBAAuB,AACvB,OAAO,AACP,iBAAiB,AACjB,eAAgB,CAUjB,AAzCL,oCAiCQ,kBAAkB,AAClB,eAAe,AACf,SAAU,CACX,AApCP,oCAsCQ,eAAe,AACf,UAAW,CACZ,AAxCP,iCA2CM,cAAc,AACd,WAAW,AACX,cAAe,CAUhB,AAvDL,mJA+CQ,cAAe,CAChB,AAhDP,4CAkDQ,eAAe,AACf,kBAAkB,AAClB,OAAO,AACP,KAAM,CACP","file":"playerbar.scss","sourcesContent":["#playerbar {\r\n  .mini-player{\r\n    display: flex;\r\n    align-items: center;\r\n    position: fixed;\r\n    left: 0;\r\n    bottom: 0;\r\n    z-index: 180;\r\n    width: 100%;\r\n    height: 3rem;\r\n    background: #333;\r\n    .icon{\r\n      flex: 0 0 40px;\r\n      width: 40px;\r\n      padding: 0 10px 0 20px;\r\n      img{\r\n        border-radius: 50%;\r\n          &.play{\r\n            animation: rotate 10s linear infinite\r\n          }\r\n          &.pause{\r\n            animation-play-state: paused\r\n          }\r\n        }\r\n      }\r\n    .text{\r\n      display: flex;\r\n      flex-direction: column;\r\n      justify-content: center;\r\n      flex: 1;\r\n      line-height: 20px;\r\n      overflow: hidden;\r\n      .name{\r\n        margin-bottom: 2px;\r\n        font-size: 16px;\r\n        color: red;\r\n      }\r\n      .desc{\r\n        font-size: 16px;\r\n        color: blue;\r\n      }\r\n    }\r\n    .control{\r\n      flex: 0 0 30px;\r\n      width: 30px;\r\n      padding: 0 10px;\r\n      .icon-play-mini, .icon-pause-mini, .icon-playlist{\r\n        font-size: 30px;\r\n      }\r\n      .icon-mini{\r\n        font-size: 32px;\r\n        position: absolute;\r\n        left: 0;\r\n        top: 0;\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 842:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(835);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(822)("fdf7e4a0", content, true);

/***/ }),

/***/ 851:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(829),
  /* template */
  __webpack_require__(856),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 856:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "playerbar"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fullScreen),
      expression: "!fullScreen"
    }],
    staticClass: "mini-player",
    on: {
      "click": _vm.open
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    class: _vm.cdCls,
    attrs: {
      "alt": "",
      "src": "//p0.ifengimg.com/pmop/2017/1106/93B9FC60B54079B13D734CADA5E7F7414E7FB626_size43_w468_h563.jpeg",
      "width": "40",
      "height": "40"
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "control"
  }), _vm._v(" "), _c('div', {
    staticClass: "control",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showPlayList($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon-playlist"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('h2', {
    staticClass: "name"
  }, [_vm._v("他为华人在国外赢了个重要官司 西方媒体却不敢报")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("test1")])])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/7.8c642c3177789c06e57d.js